export var Gender;
(function (Gender) {
    Gender[Gender["FEMALE"] = 1] = "FEMALE";
    Gender[Gender["MALE"] = 2] = "MALE";
    // OTHER = 3
})(Gender || (Gender = {}));
export const GenderTranslation = {
    [Gender.MALE]: 'Mężczyzna',
    [Gender.FEMALE]: 'Kobieta'
};
//# sourceMappingURL=gender.enum.js.map